import Popup from './organisms/Popup'
import AppNav from './organisms/AppNav'
import OfferCards from './organisms/OfferCards'
import ContentZone from './organisms/ContentZone'
import SlottedModal from './organisms/SlottedModal'
import HeroBanner from './organisms/HeroBanner/index'
import LoadingOverlay from './organisms/LoadingOverlay'
import DynamicContent from './molecules/DynamicContent'
import HeroBannerCraft from './organisms/HeroBanner/craft'
import HeroBannerPreLoad from './organisms/HeroBanner/preLoad'
import OfferLayerPreLoad from './organisms/OfferLayer/preLoad'
import CsrfTokenGenerator from './molecules/CsrfTokenGenerator'
import BusinessOfferCards from './organisms/BusinessOfferCards'
import WebFormErrorStyles from './molecules/WebFormErrorStyles'
import CheckServiceAvailability from './organisms/CheckServiceAvailability'
import SplitHeroCtaCraft from './organisms/SplitHeroCta/craft'

import {
    LiveSearch,
    PaginationNav,
    PaginatedCollectionComponent,
} from 'clockvine-vue'


// Icons
import iconPlus from './atoms/iconPlus'
import IconTv from './atoms/icons/IconTv'
import IconEye from './atoms/icons/IconEye'
import IconPin from './atoms/icons/IconPin'
import IconStar from './atoms/icons/IconStar'
import IconBars from './atoms/icons/IconBars'
import IconEdit from './atoms/icons/IconEdit'
import IconPlus from './atoms/icons/IconPlus'
import IconBase from './atoms/icons/IconBase'
import IconWifi from './atoms/icons/IconWifi'
import iconChevron from './atoms/iconChevron'
import IconTrash from './atoms/icons/IconTrash'
import IconXmark from './atoms/icons/IconXmark'
import IconCheck from './atoms/icons/IconCheck'
import IconPhone from './atoms/icons/IconPhone'
import IconPrint from './atoms/icons/IconPrint'
import IconSearch from './atoms/icons/IconSearch'
import IconEyeCancel from './atoms/icons/IconEyeCancel'
import IconRotate from './atoms/icons/IconRotate'
import IconChevronUp from './atoms/icons/IconChevronUp'
import IconCaretDown from './atoms/icons/IconCaretDown'
import IconArrowRight from './atoms/icons/IconArrowRight'
import IconCircleInfo from './atoms/icons/IconCircleInfo'
import IconCirclePlay from './atoms/icons/IconCirclePlay'
import IconStarOutline from './atoms/icons/IconStarOutline'
import IconChevronDown from './atoms/icons/IconChevronDown'
import IconCircleCheck from './atoms/icons/IconCircleCheck'
import IconChevronLeft from './atoms/icons/IconChevronLeft'
import IconCircleXmark from './atoms/icons/IconCircleXmark'
import IconCircleNotch from './atoms/icons/IconCircleNotch'
import IconCircleDollar from './atoms/icons/IconCircleDollar'
import IconChevronRight from './atoms/icons/IconChevronRight'
import IconCloudArrowUp from './atoms/icons/IconCloudArrowUp'
import IconAngleDoubleRight from './atoms/icons/IconAngleDoubleRight'
import IconCircleExclamation from './atoms/icons/IconCircleExclamation'
import IconTriangleExclamation from './atoms/icons/IconTriangleExclamation'

/* This export allows these components to be usable in Twig. In other Vue components, you still need to import them. */
export default {
    // No need to dynamically load these since they are on most pages.
    Popup,
    AppNav,
    HeroBanner,
    OfferCards,
    ContentZone,
    SlottedModal,
    DynamicContent,
    LoadingOverlay,
    HeroBannerCraft,
    HeroBannerPreLoad,
    OfferLayerPreLoad,
    BusinessOfferCards,
    WebFormErrorStyles,
    CsrfTokenGenerator,
	CheckServiceAvailability,
    SplitHeroCtaCraft,

    // Dynamically-loaded components broken into 3 files for performance reasons
    // common.js, uncommon.js, and rare.js should all be self-explanatory

    BpTabs: () => import(/* webpackChunkName: "components/rare" */ './molecules/BpTabs'),
    expandAll: () => import(/* webpackChunkName: "components/rare" */ './atoms/expandAll'),
    EbbForm: () => import(/* webpackChunkName: "components/rare" */ './organisms/EbbForm'),
    Ratings: () => import(/* webpackChunkName: "components/rare" */ './molecules/Ratings'),
    RedirectTo: () => import(/* webpackChunkName: "components/rare" */ './atoms/RedirectTo'),
    DevHelper: () => import(/* webpackChunkName: "components/common" */ './molecules/DevHelper'),
    ModalButton: () => import(/* webpackChunkName: "components/uncommon" */ './atoms/ModalButton'),
    ModalCard: () => import(/* webpackChunkName: "components/uncommon" */ './molecules/ModalCard'),
    AppFooter: () => import(/* webpackChunkName: "components/common" */ './organisms/AppFooter'),
    SiteModal: () => import(/* webpackChunkName: "components/uncommon" */ './molecules/SiteModal'),
    WifiYourWay: () => import(/* webpackChunkName: "components/rare" */ './organisms/WifiYourWay'),
    LazyFrameVideo: () => import(/* webpackChunkName: "components/rare" */ './atoms/LazyFrameVideo'),
    TierCampaign: () => import(/* webpackChunkName: "components/rare" */ './organisms/TierCampaign'),
	Location: () => import(/* webpackChunkName: "components/organisms/Location" */ './atoms/Location'),
    BpAccordion: () => import(/* webpackChunkName: "components/uncommon" */ './molecules/BpAccordion'),
    WifiHotspots: () => import(/* webpackChunkName: "components/uncommon" */ './molecules/WifiHotspots'),
    OutageAlerts: () => import(/* webpackChunkName: "components/uncommon" */ './molecules/OutageAlerts'),
    CountdownHero: () => import(/* webpackChunkName: "components/uncommon" */ './organisms/CountdownHero'),
    ChannelLineup: () => import(/* webpackChunkName: "components/common" */ './organisms/ChannelLineup'),
    HomePageBanner: () => import(/* webpackChunkName: "components/common" */ './organisms/HomePageBanner'),
    CountdownLayer: () => import(/* webpackChunkName: "components/common" */ './organisms/CountdownLayer'),
    CountdownTimer: () => import(/* webpackChunkName: "components/uncommon" */ './molecules/CountdownTimer'),
    ServiceSelector: () => import(/* webpackChunkName: "components/rare" */ './organisms/ServiceSelector'),
    ModemResetLogin: () => import(/* webpackChunkName: "components/rare" */ './organisms/ModemResetLogin'),
    InterstitialZip: () => import(/* webpackChunkName: "components/uncommon" */ './organisms/InterstitialZip'),
    WelcomeRateCard: () => import(/* webpackChunkName: "components/uncommon" */ './organisms/WelcomeRateCard'),
    ChannelsByPackage: () => import(/* webpackChunkName: "components/uncommon" */ './organisms/ChannelsByPackage'),
    InternetSpeedQuiz: () => import(/* webpackChunkName: "components/common" */ './organisms/InternetSpeedQuiz'),
    PromotionZipCodes: () => import(/* webpackChunkName: "components/rare" */ './organisms/PromotionZipCodes'),
    HighlightedOffers: () => import(/* webpackChunkName: "components/uncommon" */ './organisms/HighlightedOffers'),
    BusinessOffersForm: () => import(/* webpackChunkName: "components/common" */ './organisms/BusinessOffersForm'),
    ModemResetDashboard: () => import(/* webpackChunkName: "components/uncommon" */ './organisms/ModemResetDashboard'),
    UnserviceableAddress: () => import(/* webpackChunkName: "components/common" */ './molecules/UnserviceableAddress'),
    CheckAvailabilityZip: () => import(/* webpackChunkName: "components/common" */ './organisms/CheckAvailabilityZip'),
    BusinessOffersFormOne: () => import(/* webpackChunkName: "components/common" */ './organisms/BusinessOffersFormOne'),
    CheckAvailabilityModal: () => import(/* webpackChunkName: "components/common" */ './organisms/CheckAvailabilityModal'),
    BusinessSelectPlanModal: () => import(/* webpackChunkName: "components/common" */ './organisms/BusinessSelectPlanModal'),
    FrequentlyAskedQuestions: () => import(/* webpackChunkName: "components/common" */ './organisms/FrequentlyAskedQuestions'),
    Chat: () => import(/* webpackChunkName: "components/common" */ './molecules/Chat'),
    MovingHero: () => import(/* webpackChunkName: "components/uncommon" */ './organisms/MovingHero'),


    // Resource center components
    search: LiveSearch,
    pagination: PaginationNav,
    resources: PaginatedCollectionComponent.for('resources'),
    resourceTypes: PaginatedCollectionComponent.for('resourceTypes'),
    resourceProducts: PaginatedCollectionComponent.for('resourceProducts'),
    resourceIndustries: PaginatedCollectionComponent.for('resourceIndustries'),


    // Icons
    IconTv,
    IconEye,
	IconPin,
    IconPlus,
    iconPlus,
    IconWifi,
    IconStar,
    IconBase,
    IconBars,
    IconEdit,
    IconCheck,
    IconPhone,
    IconTrash,
    IconPrint,
    IconXmark,
    IconSearch,
    IconRotate,
    iconChevron,
    IconEyeCancel,
    IconChevronUp,
    IconCaretDown,
    IconArrowRight,
    IconCircleInfo,
    IconCirclePlay,
    IconChevronDown,
    IconCircleCheck,
    IconChevronLeft,
    IconCircleNotch,
    IconCircleXmark,
    IconStarOutline,
    IconCloudArrowUp,
    IconCircleDollar,
    IconChevronRight,
    IconAngleDoubleRight,
    IconCircleExclamation,
    IconTriangleExclamation,
}
